import { useQuery } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';

import { apiV1 } from '@/lib/axios';
import { ExtractFnReturnType, QueryConfig } from '@/lib/react-query';

import { User } from '@users/entities';

export const getUser = ({
  userId,
}: {
  userId?: string;
}): Promise<AxiosResponse<{ data: User }>> => {
  if (!userId) throw new Error(`No userId was provided on getUser request`);

  return apiV1.get(`/v1/users/${userId}`);
};

type QueryFnType = typeof getUser;

type UseUserOptions = {
  userId?: string;
  config?: QueryConfig<QueryFnType>;
};

export const useUser = ({ userId, config }: UseUserOptions) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    enabled: !!userId,
    ...config,
    queryKey: [`user`, userId],
    queryFn: () => getUser({ userId }),
  });
};
